<template>
    <div class="personal-loan-status-setting">
				<TemplateMenu :tab_name="'emailTemplate'"/>
        <CreateNewEmailTemplatesModal :create_new_email_templates.sync="modals.create_new_email_templates"  v-on:closeEmailModal="closeEmailModal()"  />
        <CreateNewNotifTemplatesModal :create_new_notif_templates.sync="modals.create_new_notif_templates"  v-on:closeNotifModal="closeNotifModal()"  />

        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Email And Notification Templates Setting</h2>
                </b-col>
                <b-col cols="6" class="text-right ">
                    <b-button variant="primary" class="btn-header" @click="openEmailModal">Create New Email Template</b-button>
                    <b-button variant="primary" class="btn-header" @click="openNotifModal">Create New Notification Template</b-button>

                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <EmailTemplatesTable />
        </b-container>
    </div>
</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import TemplateMenu from '@/views/Configurations/TemplateMenu'
import EmailTemplatesTable from '@/views/Configurations/EmailAndNotifTemplates/EmailTemplatesTable'
import CreateNewEmailTemplatesModal from '@/views/Configurations/EmailAndNotifTemplates/TemplatesModals/CreateNewEmailTemplatesModal'
import CreateNewNotifTemplatesModal from '@/views/Configurations/EmailAndNotifTemplates/TemplatesModals/CreateNewNotifTemplatesModal'

export default {
    components: {
        EmailTemplatesTable,
        RouteBreadCrumb,
        CreateNewEmailTemplatesModal,
        CreateNewNotifTemplatesModal,
				TemplateMenu
    },
    data() {
        return {
            modals: {
              create_new_email_templates: false,
              create_new_notif_templates: false

            }
        }
    },
    methods: {
        openEmailModal() {
            this.modals.create_new_email_templates = true;
        },
        closeEmailModal(){
            this.modals.create_new_email_templates = false;
        },
        openNotifModal() {
            this.modals.create_new_notif_templates = true;
        },
        closeNotifModal(){
            this.modals.create_new_notif_templates = false;
        },
    }
}
</script>